import { DashboardCard, DashboardCardProfile } from '@mdd/api';

const FILTER_PARAMETERS_APPLICABLE_TO_ALL_HERDS = [
    'count',
    'offset',
    'countLevel',
    'offsetLevel',
    'compareOffset',
    'compareOffsetLevel',
    'smoothingFactor'
];

export const getSerializedProfileRaw = (dashboardCard: DashboardCard) => {
    const profiles = dashboardCard.attributes.profiles;
    if (!profiles) return {};
    const entityId = dashboardCard.dashboard && dashboardCard.dashboard.entityId;
    if (
        dashboardCard.attributes.restoredDefaults &&
        dashboardCard.attributes.restoredDefaults.indexOf(entityId) !== -1
    ) {
        return {};
    }
    const entityIdProfile = profiles[entityId] as DashboardCardProfile;
    const allProfile = profiles['all'] as DashboardCardProfile;

    if (entityIdProfile) {
        if (
            entityIdProfile.headersInfo ||
            entityIdProfile.selectedRadioCategoryId ||
            entityIdProfile.compareMode ||
            entityIdProfile.series
        ) {
            return entityIdProfile;
        } else {
            if (allProfile) {
                return {
                    ...allProfile,
                    parameters: [
                        ...(entityIdProfile.parameters || []),
                        ...(allProfile.parameters || [])
                    ]
                };
            } else {
                return {};
            }
        }
    } else {
        return allProfile || {};
    }
    //return profiles[entityId] || profiles['all'] as DashboardCardProfile
    // return profiles[entityId] as DashboardCardProfile
};
